import { IOption } from '../interfaces/common/i-option';

export enum Competition {
  None = 'None',
  MLB = 'MLB', // america, Major League Baseball
  NCAA_D_I = 'NCAA D-I', // america, NCAA Division I
  CPBL = 'CPBL', // taiwan, Chinese Professional Baseball League
  KBO = 'KBO', // korea, Korea Baseball Organization
  NPB = 'NPB', // japan, Nippon Professional Baseball
  PrivateFacility = 'Private Facility', // e.g. driveline
}

export const COMPETITION_OPTIONS: IOption[] = [
  {
    label: Competition.None,
    value: Competition.None,
  },
  {
    label: Competition.MLB,
    value: Competition.MLB,
  },
  {
    label: Competition.NCAA_D_I,
    value: Competition.NCAA_D_I,
  },
  {
    label: Competition.CPBL,
    value: Competition.CPBL,
  },
  {
    label: Competition.KBO,
    value: Competition.KBO,
  },
  {
    label: Competition.NPB,
    value: Competition.NPB,
  },
  {
    label: Competition.PrivateFacility,
    value: Competition.PrivateFacility,
  },
];
